export default import.meta.ROLLUP_FILE_URL_o6_vqF8A4AxTSfDLUBiOEA